//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ProductDetails",
  props: {
    selected: {
      type: Object,
      default() {
        return {}
      }
    },
    typeMaterial: {
      type: Array,
      default() {
        return []
      }
    },
    stoneShapes: {
      type: Array,
      default() {
        return []
      }
    },
    stoneTypes: {
      type: Array,
      default() {
        return []
      }
    },
    info: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      stoneOneAttributeGroupe: 3,
      stoneTwoAttributeGroupe: 9
    }
  },
  computed: {
    diamondInfo() {
      return this.info.request_config.length && this.info.request_config[0].diamond_info ? this.info.request_config[0].diamond_info : {};
    },
    showStoneDetails() {
      return !(this.checkPackaging() || this.checkPendantWithoutStone());
    }
  },
  methods: {
    checkPackaging() {
      return this.info.category_code === 'packaging';
    },
    checkPendantWithoutStone() {
      return this.info.category_code === 'pendants' && !this.info.attributes?.some(item => (item.attribute_group === this.stoneOneAttributeGroupe || item.attribute_group === this.stoneTwoAttributeGroupe));
    },
    close() {
      this.$parent.$emit('changeStage', 'configurator')
    }
  },
}
